import { GET_ADDCOMPANY, GET_COMPANYLIST, GET_COMPANY_DETAILS , GET_GSTCOMPANY, GET_PARENT_COMPANYLIST, GET_UPDATECOMPANY, GET_UPDATEGSTCOMPANY, GET_PARENTCOMPANYDETAILS} from "../../resources/actionTypes";


const initialState = {
  companyList: [],
  loading: false,
  error: null,
};

const initialCompanyDetailsState = {
  companyDetails: [],
  loading: false,
  error: null,
};

const initialParentCompanyState = {
  parentCompanyList: [],
  loading: false,
  error: null,
};

const initialCompanyAdd = {
  loading: false,
  error: null,
  onBoardedCompay: ""
};

const initialUpdateCompanyAdd = {
  loading: false,
  error: null,
  updateOnBoardedCompay: ""
};

const initialGstCompany = {
  loading: false,
  error: null,
}

const initialUpdateGstCompany = {
  loading: false,
  error: null,
  updateGstCompany:""
}

const initialParentCompanyDetailsState = {
  parentCompanyDetails: [],
  loading: false,
  error: null,
};

export const userCompany = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANYLIST.GET_COMPANYLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANYLIST.GET_COMPANYLIST_SUCCESS:
      return {
        ...state,
        companyList: action.companyList,
        loading: false,
      };
    case GET_COMPANYLIST.GET_COMPANYLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_COMPANYLIST.CLEAR_COMPANYLIST:
      return {
        ...state,
        companyList: "",
        loading: false,
      };
    default:
      return state;
  }
};

export const userCompanyDetails = (state = initialCompanyDetailsState, action) => {
  switch (action.type) {
    case GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        companyDetails: action.companyProfile,
        loading: false,
      };
    case GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_COMPANY_DETAILS.CLEAR_COMPANY_DETAILS:
      return {
        ...state,
        loading: false,
        companyDetails: ""
      };
    default:
      return state;
  }
};

export const parentCompanyList = (state = initialParentCompanyState, action) => {
  switch (action.type) {
    case GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_SUCCESS:
      return {
        ...state,
        parentCompanyList: action.parentCompanyList,
        loading: false,
      };
    case GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const addCompany = (state = initialCompanyAdd, action) => {
  switch (action.type) {
    case GET_ADDCOMPANY.GET_ADDCOMPANY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDCOMPANY.GET_ADDCOMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        onBoardedCompay: action.addCompany
      };
    case GET_ADDCOMPANY.GET_ADDCOMPANY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const updateCompany = (state = initialUpdateCompanyAdd, action) => {
  switch (action.type) {
    case GET_UPDATECOMPANY.GET_UPDATECOMPANY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATECOMPANY.GET_UPDATECOMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        onBoardedCompay: action.addCompany
      };
    case GET_UPDATECOMPANY.GET_UPDATECOMPANY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const gstCompany = (state = initialGstCompany, action) => {
  switch (action.type) {
    case GET_GSTCOMPANY.GET_GSTCOMPANY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GSTCOMPANY.GET_GSTCOMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_GSTCOMPANY.GET_GSTCOMPANY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const updateGstCompany = (state = initialUpdateGstCompany, action) => {
  switch (action.type) {
    case GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const userParentCompanyDetails = (state = initialParentCompanyDetailsState, action) => {
  switch (action.type) {
    case GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_SUCCESS:
      return {
        ...state,
        parentCompanyDetails: action.parentCompanyDetails,
        loading: false,
      };
    case GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};
